import { useMemo } from 'react';

import { GridColDef } from '@mui/x-data-grid-pro';

import { useClientContext } from 'context/ClientContext';
import { CarrinhoActionColumn, CarrinhoSituacaoColumn } from 'pages/compra/carrinho/components';
import { brlPrice } from 'util/format';

export function useColumnsGrid() {
    const { tipoPedido } = useClientContext();
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';
    const isTipoPedidoPadrao = tipoPedido === 'padrao';

    const columns = useMemo((): GridColDef[] => {
        const baseColumns: GridColDef[] = [
            { field: 'nrPedido', headerName: 'Código do pedido', width: 90 },
            ...(isTipoPedidoPadrao
                ? ([
                      {
                          field: 'dsNomeFantasia',
                          headerName: 'Loja',
                          flex: 1,
                          minWidth: 170,
                          renderCell: ({ row }) => row.loja.dsNomeFantasia,
                      },
                  ] as GridColDef[])
                : []),
            {
                field: 'dsTipoPedido',
                headerName: 'Tipo do pedido',
                width: 90,
                renderCell: ({ row }) => row.configPedido.tipoPedido.dsTipoPedido,
            },
            {
                field: 'dsConfigPedido',
                headerName: 'Configuração do pedido',
                flex: 1,
                minWidth: 170,
                renderCell: ({ row }) => row.configPedido.dsConfigPedido,
            },
            ...(isTipoPedidoPadrao
                ? ([
                      { field: 'dtLimitePedido', headerName: 'Data limite do pedido', width: 90 },
                      { field: 'dtEntrega', headerName: 'Data de entrega', width: 90 },
                  ] as GridColDef[])
                : []),
            { field: 'dhInclusao', headerName: 'Data', width: 90 },
            ...(isTipoPedidoFuncionario
                ? ([
                      {
                          field: 'dsUsuario',
                          headerName: 'Funcionário',
                          minWidth: 120,
                          renderCell: ({ row }) => row.usuarioPedido?.dsUsuario,
                      },
                  ] as GridColDef[])
                : []),

            {
                field: 'vlTotal',
                headerName: 'Valor do pedido',
                type: 'number',
                align: 'right',
                width: 130,
                valueFormatter: (value) => (value ? brlPrice(value) : null),
            },
            ...(isTipoPedidoFuncionario
                ? ([
                      {
                          field: 'vlFrete',
                          headerName: 'Frete',
                          type: 'number',
                          align: 'right',
                          width: 100,
                          minWidth: 90,
                          valueFormatter: (value) => brlPrice(value),
                      },
                      {
                          field: 'vlTotalFrete',
                          headerName: 'Total do pedido',
                          type: 'number',
                          align: 'right',
                          width: 120,
                          minWidth: 110,
                          valueFormatter: (value) => brlPrice(value),
                      },
                  ] as GridColDef[])
                : []),
            {
                field: 'idStatusRascunho',
                headerName: 'Status',
                align: 'center',
                headerAlign: 'center',
                minWidth: 170,
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                renderCell: ({ row }) => <CarrinhoSituacaoColumn row={row} />,
            },
            {
                field: 'Ações',
                align: 'center',
                headerAlign: 'center',
                minWidth: 160,
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                renderCell: ({ row }) => <CarrinhoActionColumn row={row} />,
            },
        ];

        return baseColumns;
    }, []);

    return { columns };
}
